import { useState } from "react";
import Content from "../component/Content";
import Header from "../component/Header";
import Sidebar from "../component/Sidebar";

const Layout = ({ children, module, title, breadcrumb }) => {
  const [showSidebar, setShowSidebar] = useState(false);
  const toogleClicked = () => {
    setShowSidebar(!showSidebar);
  };
  return (
    <div className={`bxoInner ${showSidebar ? "menu-clicked" : ""}`}>
      <Header toogleClicked={toogleClicked} />
      <Sidebar module={module} toogleClicked={toogleClicked} />
      <Content
        breadcrumb={breadcrumb}
        title={title}
        children={children}
        module={module}
      />
      <footer class="footer">
        <p>© 2022 BigPurple, all rights reserved.</p>
      </footer>
    </div>
  );
};
export default Layout;
